import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 10000,
});

//#region interceptor request
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);
//#endregion


//#region interceptor response
api.interceptors.response.use(
    
    (response) => response,
    (error) => {

        const status = error?.response?.status;

        if (status === 401) {
        console.log("❌ 401: sessão expirada ou token inválido");
        localStorage.removeItem("token");
        // window.location.href = "/login"; // opcional
        }

        return Promise.reject(error);
    }
);
//#endregion

export default api;
